import { PluginService } from '../../plugins/services/plugin.service';
import { DependencyInjector } from '../../support/injector';
import { EntityService } from '../../entities/services/entity.service';
import { QuickAdditTabManager } from './tab-manager.class';
import { PluginProxy } from './plugin-proxy.class';

export class QuickAdditEntity {

    public defaultProperties = {};

    protected tabService;

    protected pluginService;

    protected multiStepper = false;

    protected steps: Array<Step>;

    public constructor(public name: string, public service: Object) {
        this.tabService    = new QuickAdditTabManager();
        this.pluginService = new PluginProxy(DependencyInjector.get(PluginService), this.name);
    }

    public multiStep(steps: Array<Step>) {
        this.multiStepper = true;

        this.steps = steps;

        return this;
    }

    public isMultiStepper() {
        return this.multiStepper;
    }

    public getSteps(index?: number) {

        if (index >= 0) {
            return this.steps[index];
        }

        return this.steps;
    }

    public defaults(defaults: Object) {
        this.defaultProperties = defaults;

        return this;
    }

    public tabs(callback: (tabs: QuickAdditTabManager) => void): this {
        callback(this.tabService);

        return this;
    }

    public plugins(callback: (plugins: PluginProxy) => void): this {
        callback(this.pluginService);

        return this;
    }

    public getFormStructure(create = true) {
        const entityService: EntityService = DependencyInjector.get(EntityService);

        const groups    = JSON.parse(JSON.stringify(entityService.getDefaultForm(this.name).groups));
        const structure = {groups: groups};

        this.tabService.all().forEach(tab => {
            if (tab.options.createOrEdit && (!create && tab.options.createOrEdit !== 'edit' || create && tab.options.createOrEdit !== 'create')) {
                return;
            }

            const slotName = 'quick-addit-' + this.name + '-entity-' + tab.name + '-' + (create ? 'create' : 'edit');

            tab.sections = [{
                name: '',
                title: '',
                show_label: false,
                rows: [
                    {
                        row_related: '',
                        elements: [],
                        pluginSlots: [slotName]
                    }
                ]
            }];

            tab = this.evaluateTabOrder(tab, structure.groups);

            structure.groups.push(tab);
        });

        return structure;
    }

    private evaluateTabOrder(tab, groups) {

        if (tab.options.order) {
            tab.order = tab.options.order;
            return tab;
        }

        // find group with highest order number
        const groupWithHighestOrder = groups.reduce((accumulator, currentValue) => {

            if (!accumulator) {
                return currentValue;
            }

            if (currentValue.order > accumulator.order) {
                return currentValue;
            }

            return accumulator;
        });

        tab.order = groupWithHighestOrder.order + 1;
        return tab;
    }
}

export class Step {

    structure: Object;
    mode?: 'create' | 'edit' | 'both';
    success?: Function;

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/quick-addit/classes/entity.class.ts